import { useEffect, useState } from 'react'
import styled from 'styled-components'
import useUserIntakePreferencesFetcher from '../../../hooks/useUserIntakePreferencesFetcher'
import { RequestService } from '../../../services/RequestService'
import IntakeCaffeineType from './IntakeCaffeineType'
import IntakeCaffeineTime from './IntakeCaffeineTime'
import { useSnackbar } from '../../../hooks'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 44px;
`

const Caffeine = ({
  id,
  caffeineProducts,
  setCaffeineProducts,
  selectedCaffeineOptions,
  onSelectCaffeineOptions,
  caffeineTime,
  onChangeCaffeineTime,
  onPrevious,
  onFinish,
}) => {
  const [currentStep, setCurrentStep] = useState(0)
  const { data } = useUserIntakePreferencesFetcher()
  const { errorSnackbar } = useSnackbar()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (data) {
      const { caffeineProducts } = data

      setCaffeineProducts(caffeineProducts)
    }
  }, [data])

  const handleNext = () => {
    setCurrentStep(prevStep => prevStep + 1)
  }

  const handlePrevious = () => {
    setCurrentStep(prevStep => prevStep - 1)
  }

  const handleFinish = async ({ caffeineTime }) => {
    const { status } = await RequestService.updateIntake({
      id,
      type: 'caffeine',
      caffeinePreferences: selectedCaffeineOptions,
      caffeineTime,
    })

    if (status === RequestService.STATUSES.SUCCESS) {
      onFinish()
    } else {
      errorSnackbar({ text: response.message })
    }
  }

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <IntakeCaffeineType
            step={t('caffeine.two_steps.one')}
            caffeineProducts={caffeineProducts}
            selectedCaffeineOptions={selectedCaffeineOptions}
            setSelectedCaffeineOptions={onSelectCaffeineOptions}
            onNext={handleNext}
            onPrevious={onPrevious}
            onFinish={onFinish}
          />
        )
      case 1:
        return (
          <IntakeCaffeineTime
            step={t('caffeine.two_steps.two')}
            caffeineTime={caffeineTime}
            setCaffeineTime={onChangeCaffeineTime}
            onNext={() => handleFinish({ caffeineTime })}
            onPrevious={handlePrevious}
          />
        )
      default:
        return null
    }
  }

  return <Container>{renderStep()}</Container>
}

export default Caffeine
